import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles(() => ({
  container: {
    maxWidth: "100%",
  },

  header: {
    backgroundColor: "#1a2332",
    color: "white",
    padding: rem(20),
    borderRadius: rem(8),
    marginBottom: rem(20),
    "@media print": {
      backgroundColor: "#1a2332 !important",
      color: "white !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  headerTitle: {
    fontSize: rem(28),
    fontWeight: 700,
    color: "white",
    "@media print": {
      color: "white !important",
    },
  },

  forgeryBadge: {
    backgroundColor: "#22c55e",
    color: "white",
    padding: `${rem(4)} ${rem(12)}`,
    borderRadius: rem(20),
    fontSize: rem(12),
    fontWeight: 600,
    "@media print": {
      backgroundColor: "#22c55e !important",
      color: "white !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  forgeryTrue: {
    backgroundColor: "#F00",
    "@media print": {
      backgroundColor: "#F00 !important",
      color: "white !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  section: {
    marginBottom: rem(24),
    "@media print": {
      breakInside: "avoid",
    },
  },

  sectionTitle: {
    fontSize: rem(18),
    fontWeight: 700,
    marginBottom: rem(12),
    color: "#1a2332",
    "@media print": {
      color: "#000000 !important",
    },
  },

  card: {
    border: "1px solid #e5e7eb",
    borderRadius: rem(8),
    padding: rem(16),
    marginBottom: rem(16),
    backgroundColor: "white",
    color: "#1f2937",
    "@media print": {
      border: "1px solid #000000",
      color: "#000000 !important",
    },
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",

    "& th": {
      backgroundColor: "#1a2332",
      color: "white",
      padding: rem(12),
      textAlign: "left",
      fontSize: rem(14),
      fontWeight: 600,
    },

    "& td": {
      padding: rem(12),
      borderBottom: "1px solid #e5e7eb",
      fontSize: rem(14),
      color: "#1f2937",
    },

    "& tr:nth-of-type(even)": {
      backgroundColor: "#f9fafb",
    },

    "@media print": {
      "& th": {
        backgroundColor: "#1a2332 !important",
        color: "white !important",
        "-webkit-print-color-adjust": "exact",
        "print-color-adjust": "exact",
      },
      "& td": {
        color: "#000000 !important",
        borderBottom: "1px solid #cccccc",
      },
      "& tr:nth-of-type(even)": {
        backgroundColor: "#f0f0f0 !important",
      },
      breakInside: "avoid",
    },
  },

  infoTable: {
    width: "100%",

    "& th": {
      backgroundColor: "#1a2332",
      color: "white",
      padding: rem(10),
      textAlign: "left",
      fontSize: rem(13),
      fontWeight: 600,
      width: "30%",
    },

    "& td": {
      padding: rem(10),
      borderBottom: "1px solid #e5e7eb",
      fontSize: rem(13),
      color: "#1f2937",
    },

    "@media print": {
      "& th": {
        backgroundColor: "#1a2332 !important",
        color: "white !important",
        "-webkit-print-color-adjust": "exact",
        "print-color-adjust": "exact",
      },
      "& td": {
        color: "#000000 !important",
      },
    },
  },

  appendixSection: {
    backgroundColor: "#1a2332",
    color: "white",
    padding: rem(24),
    borderRadius: rem(8),
    marginTop: rem(24),
    "@media print": {
      backgroundColor: "#ffffff !important",
      color: "#000000 !important",
      border: "2px solid #1a2332",
      padding: rem(24),
    },
  },

  appendixTitle: {
    fontSize: rem(24),
    fontWeight: 700,
    marginBottom: rem(20),
    color: "white",
    "@media print": {
      color: "#1a2332 !important",
    },
  },

  appendixSubtitle: {
    fontSize: rem(16),
    fontWeight: 600,
    marginBottom: rem(12),
    color: "white",
    "@media print": {
      color: "#1a2332 !important",
    },
  },

  appendixTable: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: rem(20),

    "& th": {
      backgroundColor: "#2d3748",
      color: "white",
      padding: rem(10),
      textAlign: "left",
      fontSize: rem(13),
    },

    "& td": {
      padding: rem(10),
      borderBottom: "1px solid #4a5568",
      fontSize: rem(13),
      color: "white",
    },

    "@media print": {
      "& th": {
        backgroundColor: "#e5e7eb !important",
        color: "#000000 !important",
        border: "1px solid #cccccc",
        "-webkit-print-color-adjust": "exact",
        "print-color-adjust": "exact",
      },
      "& td": {
        color: "#000000 !important",
        borderBottom: "1px solid #cccccc",
        border: "1px solid #cccccc",
      },
    },
  },

  statusBadge: {
    padding: `${rem(4)} ${rem(8)}`,
    borderRadius: rem(4),
    fontSize: rem(12),
    fontWeight: 600,
  },

  statusTidakLancar: {
    backgroundColor: "#F00",
    color: "white",
    "@media print": {
      backgroundColor: "#F00 !important",
      color: "white !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  statusLancar: {
    backgroundColor: "#22c55e",
    color: "white",
    "@media print": {
      backgroundColor: "#22c55e !important",
      color: "white !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  statusOverdue: {
    backgroundColor: "#f59e0b",
    color: "white",
    "@media print": {
      backgroundColor: "#f59e0b !important",
      color: "white !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  verified: {
    color: "#22c55e",
    "@media print": {
      color: "#166534 !important",
    },
  },

  notVerified: {
    color: "#ef4444",
    "@media print": {
      color: "#dc2626 !important",
    },
  },

  commentSection: {
    marginTop: rem(32),
    padding: rem(20),
    border: "1px solid #e5e7eb",
    borderRadius: rem(8),
    "@media print": {
      border: "1px solid #000000",
      breakInside: "avoid",
    },
  },

  commentItem: {
    padding: rem(16),
    borderBottom: "1px solid #e5e7eb",

    "&:last-child": {
      borderBottom: "none",
    },
  },

  commentAuthor: {
    fontWeight: 600,
    color: "#1a2332",
    "@media print": {
      color: "#000000 !important",
    },
  },

  commentTime: {
    fontSize: rem(12),
    color: "#4b5563",
    "@media print": {
      color: "#000000 !important",
    },
  },

  commentText: {
    marginTop: rem(8),
    color: "#1f2937",
    "@media print": {
      color: "#000000 !important",
    },
  },

  summaryBox: {
    backgroundColor: "#f3f4f6",
    padding: rem(16),
    borderRadius: rem(8),
    marginBottom: rem(16),
    color: "#1f2937",
    "@media print": {
      backgroundColor: "#f3f4f6 !important",
      color: "#000000 !important",
      border: "1px solid #cccccc",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  discrepancyItem: {
    padding: rem(12),
    backgroundColor: "#fef3c7",
    borderRadius: rem(6),
    marginBottom: rem(8),
    borderLeft: `4px solid #f59e0b`,
    color: "#1f2937",
    "@media print": {
      backgroundColor: "#fef3c7 !important",
      color: "#000000 !important",
      "-webkit-print-color-adjust": "exact",
      "print-color-adjust": "exact",
    },
  },

  printButton: {
    backgroundColor: "#1a2332",
    color: "white",
    "&:hover": {
      backgroundColor: "#2d3748",
    },
    "@media print": {
      display: "none !important",
    },
  },

  // Hide interactive elements when printing
  noPrint: {
    "@media print": {
      display: "none !important",
    },
  },
}));
